export default __webpack_public_path__ + "static/media/story_keywords.ff2ffbc3.png";